import ProductDescription from './ProductDescription'

const BrownRiceProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '003',
  IsBroadband: true,
  GrainSize: '16 ounces only',
  CookingType: '',
  OatVariety: '',
  GrainLength: '',
  otherType: '',
}

export default BrownRiceProduct
